/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EnvironmentWarning/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function EnvironmentWarning({
  children,
  viewPath = "/App/Account/Topbar/EnvironmentWarning"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appEnvironmentValueData = fromData.useDataFormat({ viewPath,
context: 'app',
path: 'environment',
format: fromHelpers.showWarning,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(appEnvironmentValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}